import { palette } from '@openx/components-core/lib/theme/paletteV2';

export const getColorForDspName = (index: number): string => {
  const colors = [
    palette.charts.indigo,
    palette.charts.lightBlue,
    palette.charts.blue,
    palette.charts.orchid,
    palette.charts.purple,
    palette.charts.pink,
  ];
  return colors[index % colors.length];
};
